import { createSelector } from "reselect"
import { createQueryStringSelector } from "."
import { computePeriodOrStartAndEndDates } from "helpers/dates"

export const getRawPeriod = createQueryStringSelector("period")
export const getRawStartDate = createQueryStringSelector("startDate")
export const getRawEndDate = createQueryStringSelector("endDate")
export const getRawDate = createQueryStringSelector("date")

export const getPeriodOrStartAndEndDates = createSelector(
  [getRawPeriod, getRawStartDate, getRawEndDate],
  computePeriodOrStartAndEndDates,
)
